import { PlusIcon } from 'public/svg/IconsSvg';

export const VirtualSetPlusIcon: FC = () => {
    return (
        <div className="flex h-7 w-7 items-center justify-center rounded-full bg-green">
            <PlusIcon className="h-4 w-4 stroke-[3] text-white" />
        </div>
    );
};
